let isReady = document.readyState === "complete"
    || document.readyState === "interactive";
const waiter: (() => void)[] = [];
const handleReadyStateChange = (e: Event) => {
    if (document.readyState === "complete"
        || document.readyState === "interactive"
    ) {
        isReady = true;

        document.removeEventListener("readystatechange", handleReadyStateChange);

        if(!document.body){
            console.warn("e5.ready() not triggered because the document.body is not available yet.")
            return;
        }

        for (const callback of waiter) {
            callback();
        }
        waiter.slice(0);
    }
}
document.addEventListener("readystatechange", handleReadyStateChange);

export const ready = (callback: () => void) => {
    if (isReady) {
        callback();
    } else {
        waiter.push(callback);
    }
};